import { TRESPONSE_PLANNING_BOARD_DAYWISE_ORDER_STATUS_BY_OTLID } from '@monorepo/types';
import moment from 'moment';
import { ModifiersZTableModel } from '../../table.modifier';

export const ORDER_DAY_WISE_STATUS_TABLE_MODEL = {
  createModel: (res: TRESPONSE_PLANNING_BOARD_DAYWISE_ORDER_STATUS_BY_OTLID['dateWiseQtyDetails']) => {
    const rows: {
      label: string;
      key: keyof TRESPONSE_PLANNING_BOARD_DAYWISE_ORDER_STATUS_BY_OTLID['dateWiseQtyDetails'][number];
    }[] = [{ label: 'Planned Qty', key: 'plannedQty' }];

    return ModifiersZTableModel.createTableModel(
      rows,
      {
        headerConfig: [
          {
            type: 'TEXT_CELL' as const,
            text: 'Date',
            stickyType: 'LEFT' as const,
            stickyPosition: 1,
          },
          ...res.map((hInfo) => ({
            type: 'TEXT_CELL' as const,
            text: moment(hInfo.date).format('DD MMM YYYY'),
          })),
        ],
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            { type: 'TEXT_CELL', text: item.label, align: 'left' as const },
            ...res.map((itemInfo) => ({ type: 'TEXT_CELL' as const, text: itemInfo[item.key] ?? '- -' })),
          ],
        };
      },
    );
  },
};
